module.exports = __webpack_public_path__ + "RiyazAkramShaik-82bd4845.webp";